import React from 'react';
import ReactDOM from 'react-dom';
import { App, AppProps } from './app';
import './styles/index.scss';
import { AssessorRegistry } from './registries/AssessorRegistry';
import { CallsignsRegistry } from './registries/CallsignRegistry';

export * from './portal/appRoutes';

export * from './portal/dashboard';

export function renderSpa(e: Element, props: AppProps & { hint?: string }) {
  let elementToRender: React.JSX.Element;

  if (props.hint == 'assessors') {
    elementToRender = <AssessorRegistry {...props} />;
  } else if (props.hint == 'callsigns') {
    elementToRender = <CallsignsRegistry {...props} />;
  } else {
    elementToRender = <App {...props} />;
  }

  ReactDOM.render(<React.StrictMode>{elementToRender}</React.StrictMode>, e);
}
